import { Phone, Mail, MapPin, Instagram, Facebook, Linkedin } from "lucide-react";
import { BRAND, NAV_LINKS } from "../lib/constants";

const KEYWORDS = [
    "Construction Company in Udaipur",
    "Best Home Builder in Udaipur",
    "Interior Designer Udaipur",
    "Luxury Home Construction Rajasthan",
    "Turnkey Construction Services Udaipur",
];

export default function Footer() {
    return (
        <footer className="bg-brand-ink text-white border-t border-white/10" data-testid="footer">
            <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 md:py-20">
                <div className="grid md:grid-cols-12 gap-10 md:gap-12 mb-12">
                    <div className="md:col-span-5">
                        <a href="#top" className="inline-block mb-6" aria-label="Dhanshree Constructions">
                            <img
                                src={BRAND.logo}
                                alt="Dhanshree Constructions"
                                className="h-11 w-auto object-contain"
                            />
                        </a>
                        <p className="text-white/60 text-[15px] leading-relaxed max-w-md">
                            Udaipur's trusted end-to-end construction & luxury home interior
                            specialists. Turning dreams into concrete reality, one home at a time.
                        </p>
                        <div className="mt-7 flex items-center gap-2.5">
                            {[Instagram, Facebook, Linkedin].map((Icon, i) => (
                                <a
                                    key={i}
                                    href="#"
                                    className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-white/70 hover:bg-white hover:text-brand-ink hover:border-white transition-colors"
                                    aria-label="Social link"
                                    data-testid={`footer-social-${i}`}
                                >
                                    <Icon size={15} />
                                </a>
                            ))}
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-[10px] uppercase tracking-[0.2em] text-white/40 mb-5">Explore</div>
                        <ul className="space-y-3">
                            {NAV_LINKS.map((l) => (
                                <li key={l.href}>
                                    <a href={l.href} className="text-white/75 hover:text-[#FF8800] transition-colors text-[14px]">
                                        {l.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="text-[10px] uppercase tracking-[0.2em] text-white/40 mb-5">Get in touch</div>
                        <ul className="space-y-3.5 text-[14px]">
                            <li className="flex items-center gap-3">
                                <Phone size={14} className="text-white/50" />
                                <a href={`tel:${BRAND.phoneRaw}`} className="text-white/80 hover:text-[#FF8800] transition-colors" data-testid="footer-phone">
                                    {BRAND.phone}
                                </a>
                            </li>
                            <li className="flex items-center gap-3">
                                <Mail size={14} className="text-white/50" />
                                <a href={`mailto:${BRAND.email}`} className="text-white/80 hover:text-[#FF8800] transition-colors break-all" data-testid="footer-email">
                                    {BRAND.email}
                                </a>
                            </li>
                            <li className="flex items-center gap-3">
                                <MapPin size={14} className="text-white/50" />
                                <span className="text-white/80">{BRAND.location}</span>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* SEO keyword strip */}
                <div className="border-t border-white/10 pt-7">
                    <div className="text-[10px] uppercase tracking-[0.2em] text-white/30 mb-3">Serving</div>
                    <div className="flex flex-wrap gap-2">
                        {KEYWORDS.map((k) => (
                            <span key={k} className="text-[11px] text-white/45 px-3 py-1.5 rounded-full border border-white/10">
                                {k}
                            </span>
                        ))}
                    </div>
                </div>

                <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-[11px] text-white/40">
                    <div>© {new Date().getFullYear()} Dhanshree Constructions. All rights reserved.</div>
                    <div>Crafted with care in Udaipur, Rajasthan.</div>
                </div>
            </div>
        </footer>
    );
}
